import { Avatar, Box, Container, Grid, Modal, Typography } from "@mui/material";
import React, { useState, useRef, useContext, useEffect } from "react";
import bg from "../@shared/assets/mydecksbg.png";
import bg1 from "../@shared/assets/dashboard_header.png";
import { useNavigate } from "react-router-dom";
import NeoButton from "../components/NeoButton";
import JoinRoomModal from "../components/JoinRoomModal";
import JoinPartyModal from "../components/JoinPartyModal";
import StartRoomModal from "../components/StartRoomModal";
import { useAuthStore } from "../@shared/store/useAuthStore";
import SpriteAnimator from "../components/gamePlay/SpriteAnimator";
import PackOpeningModal from "../components/PackOpeningModal";
import {
  getBadgeByLevel,
  formatNumber,
  getQuestProgress,
} from "../@shared/utils/Utils";
import QuestsAndRewardsModal from "../components/QuestsAndRewardsModal";
import LeaderBoardModal from "../components/LeaderBoardModal";
import { MainContext } from "../App";
import VoidCityScene from "../components/mapScenes/voidCity/VoidCityScene";
import SettingsDrawer from "../components/SettingsDrawer";
import WebJoystick from "../components/WebJoystick";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import NeoMenuItem from "../components/NeoItem";
import {
  Add,
  AddRoadRounded,
  AddRounded,
  ArrowForwardIos,
  MenuRounded,
} from "@mui/icons-material";
import { starterQuests } from "../@shared/game/starterQuests";
import MyQuestsModal from "../components/MyQuestsModal";
import HowToPlayModal from "../components/HowToPlayModal";
import Toast from "../components/Toast";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../@shared/firebase/config";
import { useTutorial } from "../@shared/utils/useTutorial";
import InfinityOrb from "../components/InfinityOrb";
import TutorialInfinityOrb from "../components/TutorialInfinityOrb";
import { motion, useSpring } from "framer-motion";
import { startScreenTransition } from "../@shared/utils/startScreenTransition";
import MyPurchasesModal from "../components/PurchasesModal";
import AvatarIdolAnimation from "../components/idolAvatarAnimations/AvatarIdolAnimation";
import AvatarSelectorModal from "../components/mainMenu/AvatarSelectorModal";

// import EditProfileModal from "./EditProfileModal";

const Dashboard = () => {
  const {
    navigate,
    partyId,
    setPartyId,
    setIsHost,
    isHost,
    Theme,
    setInfo,
    setMessage,
    deviceType,
    setScreenLoading,
    gameScreenLoading,
    setGameScreenLoading,
  } = useContext(MainContext);
  const isMobile = deviceType === "mobile";
  const theme = useTheme();

  // true if viewport width is 600px or less (MUI's `sm` breakpoint)
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));

  //userData ====================================
  const { userData } = useAuthStore();
  const [rewards, setRewards] = useState(userData?.rewards || []);
  const [quests, setQuests] = useState(userData?.quests || []);
  const [questLog, setQuestLog] = useState(userData?.questLog || []);
  const [infinityTokens, setInfinityTokens] = useState(
    userData?.infinityTokens || "0"
  );

  const [modalOpen, setModalOpen] = useState(false);
  const [settingsVisible, setSettingsVisible] = useState(false);
  const [howToPlayVisible, setHowToPlayVisible] = useState(false);

  const [startRoomVisible, setStartRoomVisible] = useState(false);
  const [joinRoomVisible, setJoinRoomVisible] = useState(false);
  const [joinPartyVisible, setJoinPartyVisible] = useState(false);
  const [questsAndRewardsVisible, setQuestsAndRewardsVisible] = useState(false);
  const [packOpeningVisible, setPackOpeningVisible] = useState(false);
  const [leaderboardVisible, setLeaderboardVisible] = useState(false);
  const [myQuestsVisible, setMyQuestsVisible] = useState(false);
  const [myPurchasesVisible, setMyPurchasesVisible] = useState(false);
  const [townQuestsVisible, setTownQuestsVisible] = useState(false);
  const [avatarSelectorVisible, setAvatarSelectorVisible] = useState(false);
  const [townQuests, setTownQuests] = useState(starterQuests);

  const [isCheckingMatch, setIsCheckingMatch] = useState(true);
  const [resumingMatch, setResumingMatch] = useState(false);
  const spriteRef = useRef(null);

  const [canInteract, setCanInteract] = useState(false);

  const ySpring = useSpring(0, {
    stiffness: 60,
    damping: 15,
  });

  useEffect(() => {
    const cb = (e) => setCanInteract(e.detail);
    window.addEventListener("interact-proximity", cb);
    return () => window.removeEventListener("interact-proximity", cb);
  }, []);

  useEffect(() => {
    const loop = () => {
      ySpring.set(-5);
      setTimeout(() => ySpring.set(5), 500);
      setTimeout(() => ySpring.set(-5), 1000);
    };
    const interval = setInterval(loop, 1000);
    return () => clearInterval(interval);
  }, []);

  const unclaimedRewardsAndQuests = rewards?.filter(
    (r) => r.claimed === false
  ).length;

  useEffect(() => {
    if (!userData) {
      navigate("/");
    } else if (userData?.partyId) {
      setScreenLoading(true);
      const timeout = setTimeout(() => {
        navigate("/world");
      }, 500); // small delay, but lets TransitionOverlay take over

      return () => clearTimeout(timeout);
    }

    if (userData && !userData?.partyId) {
      setScreenLoading(false);
    }
    console.log(userData);
  }, [userData]);

  useEffect(() => {
    const original = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = original;
    };
  }, []);

  //   useEffect(() => {
  //     if (partyId && isHost !== null) {
  //       navigate("/world");
  //     }
  //   }, [partyId, isHost]);

  // listen for our Phaser “door-proximity” events
  useEffect(() => {
    const cb = (e) => setCanInteract(e.detail);
    window.addEventListener("interact-proximity", cb);
    return () => window.removeEventListener("interact-proximity", cb);
  }, []);

  if (!userData) {
    return null;
  }

  const handleStartParty = async (isNew) => {
    // Generate a random 5-digit number
    const randomNumber = Math.floor(Math.random() * 90000) + 10000;
    const userDocRef = doc(db, "users", userData.id);
    await updateDoc(
      userDocRef,
      isNew
        ? {
            partyId: randomNumber,
            isHost: true,
            completedTutorial: false,
          }
        : {
            partyId: randomNumber,
            isHost: true,
          }
    );
  };

  const handleJoyMove = (dx, dy) => {
    window.dispatchEvent(
      new CustomEvent("joystick-move", { detail: { dx, dy } })
    );
  };
  const handleJoyRelease = () => {
    window.dispatchEvent(new Event("joystick-release"));
  };

  return (
    <Grid
      container
      xs={12}
      sx={{
        // p: { xs: 0, md: 2 },
        height: "100%",
        width: "100%",
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <Toast onFinish={() => {}} timeTilClose={3000} />
      <SettingsDrawer
        open={settingsVisible}
        onClose={() => setSettingsVisible(false)}
      />
      <Container
        // maxWidth="xl"
        maxWidth={false}
        disableGutters
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          p: { xs: 0 },
        }}
      >
        {/* Dashboard Info Container */}
        <Grid
          item
          container
          xs={12}
          sm={10}
          md={6}
          lg={5}
          xl={5}
          sx={{
            ...styles.container,
            display: { xs: "flex" },
            flexDirection: { xs: "column", md: "row" },
            height: "100%",
            borderRadius: "10px",
            position: "absolute",
          }}
        >
          {/* Menu Container */}
          <Grid
            xs={12}
            sx={{
              ...styles.container,
              display: "flex",
              // let height shrink on mobile
              height: "100%",
              top: { xs: "-1%", md: 2 },
              right: { xs: "2%", md: 0 },
              p: { xs: 1, sm: 2, md: 3, lg: 4 },
              pl: { xs: 2, sm: 3, md: "38px", lg: "48px" },
              flexDirection: "column",
              position: "relative",
            }}
          >
            {/* Wrapper container to stack everything inside */}
            <Grid container direction="column" style={{ height: "100%" }}>
              {/* Stats + Achievements Row */}
              <Grid
                container
                item
                sx={{
                  width: "100%",
                  mb: { xs: 2, md: 1 },
                  padding: "10px",
                }}
              >
                <Grid
                  item
                  container
                  xs={12}
                  sx={styles.sectionBox}
                  style={{
                    padding: 0,
                    justifyContent: "space-between",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      height: 60,
                      width: 50,
                      position: "relative",
                    }}
                  >
                    <NeoButton
                      isIcon={true}
                      icon={<MenuRounded />}
                      color={Theme.palette.tirciary.main}
                      width={100}
                      borderRadius={14}
                      onClick={() => setSettingsVisible(true)}
                    />
                  </Box>

                  {/* <Avatar
                      src={
                        userData?.imgUrl
                          ? userData.imgUrl
                          : require("../@shared/assets/icons/profile_icon.png")
                      }
                      style={{
                        width: 50,
                        height: 50,
                        position: "absolute",
                        left: window.innerWidth >= 900 ? 0 : -10,
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                      }}
                    />

                    <Box
                      sx={{
                        width: 38,
                        height: 38,
                        position: "absolute",
                        right: "-35%",
                        bottom: "-30%",
                        zIndex: 100,
                      }}
                    >
                      <Box
                        sx={{
                          width: "100%",
                          height: "100%",
                          position: "relative",
                        }}
                      >
                        <img
                          src={getBadgeByLevel(userData.level).badge}
                          alt=""
                          style={{
                            width: "100%",
                            height: "100%",
                            position: "relative",
                            left: window.innerWidth >= 900 ? 0 : -42,
                          }}
                        />
                        <Typography
                          variant="caption"
                          style={{
                            fontWeight: "bold",
                            position: "absolute",
                            top: "50%",
                            left: window.innerWidth >= 900 ? "50%" : "-62%",
                            transform: "translate(-50%, -50%)",
                            color: "#fff",
                          }}
                        >
                          {userData.level}
                        </Typography>
                      </Box>
                    </Box> */}

                  {/* TOKENS  */}

                  <Box
                    sx={{
                      position: "relative",
                    }}
                  >
                    <NeoMenuItem
                      icon={require("../@shared/assets/infift_token.png")}
                      label={formatNumber(infinityTokens) || 0}
                      onClick={() => {
                        if (userData?.roles.includes("admin")) {
                          setPackOpeningVisible(true);
                        } else {
                          console.log(
                            "Open a modal showning the amount of tokens"
                          );
                          setMessage("Infinity Tokens will be available soon!");
                          setInfo(true);
                          //   setInfinityTokensVisible(true);
                        }
                      }}
                      endAdorn={
                        <Add
                          style={{
                            marginLeft: 2,
                            fontSize: 20,
                            color: "#fee399",
                          }}
                        />
                      }
                    />
                  </Box>

                  <Box
                    sx={{
                      position: "relative",
                    }}
                  >
                    <NeoMenuItem
                      onClick={() => {
                        setQuestsAndRewardsVisible(true);
                      }}
                      label={
                        unclaimedRewardsAndQuests > 99
                          ? "99+"
                          : unclaimedRewardsAndQuests
                      }
                      icon={require("../@shared/assets/icons/reward_icon.png")}
                      redDot={unclaimedRewardsAndQuests > 1 ? true : false}
                    />
                  </Box>

                  <Box
                    sx={{
                      position: "relative",
                    }}
                  >
                    <NeoMenuItem
                      onClick={() => {
                        setMyQuestsVisible(true);
                      }}
                      label={
                        quests?.filter((quest) => !quest.completed).length > 99
                          ? "99+"
                          : quests?.filter((quest) => !quest.completed).length
                      }
                      icon={require("../@shared/assets/icons/quest_scroll_icon.png")}
                      redDot={quests?.find(
                        (quest) =>
                          !quest.completed &&
                          getQuestProgress(quest, questLog) >= quest.goal
                      )}
                    />
                  </Box>

                  {/* REWARDS && QUESTS * */}
                  {/* LEADERBAORDS */}
                  <Box
                    sx={{
                      width: "30px",
                      height: "30px",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      position: "relative",
                      cursor: "pointer",
                      top: { xs: 0, md: "10%" },
                    }}
                    onClick={() => {
                      //   spriteRef.current?.start(),
                      //   setPackOpeningVisible(true);
                      console.log("LEADERBOARD");
                      setLeaderboardVisible(true);
                      // handleNavigate("Test");
                    }}
                  >
                    <img
                      alt=""
                      src={require("../@shared/assets/icons/trophy_icon.png")}
                      style={{
                        width: 35,
                        height: 35,
                        position: "absolute",
                        left: window.innerWidth >= 900 ? -10 : 10,
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>

              {/* Menu Buttons Row */}
              <Grid
                item
                container
                style={{
                  position: "relative",
                  height: "calc(100% - 100px)",
                  padding: "10px",
                }}
              >
                {/* {!userData.test && (
                  <Grid
                    item
                    container
                    xs={12}
                    sx={{
                      ...styles.menuButton,
                      // backgroundColor: "#00aaff",
                      mb: 0,
                    }}
                  >
             
                    <NeoButton
                      text="Enter World"
                      // subText="Create a private or public battle."
                      width={100}
                      color="#00aaff"
                      height={60}
                      onClick={handleStartParty}
                    />
                  </Grid>
                )}

                <Grid
                  item
                  container
                  xs={12}
                  sx={{
                    ...styles.menuButton,
                    // backgroundColor: "#4b2cff",
                    mb: 0,
                  }}
                >
                  <NeoButton
                    text="Party Play"
                    subText="Enter a code or browse active rooms."
                    width={100}
                    color="#4b2cff"
                    height={60}
                    onClick={() => setJoinPartyVisible(true)}
                  />
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sx={{
                    ...styles.menuButton,
                    // backgroundColor: "#4b2cff",
                    mb: 0,
                  }}
                >
                  <NeoButton
                    text="Quick Play"
                    subText="Enter a code or browse active rooms."
                    width={100}
                    color={Theme.palette.tirciary.main}
                    height={60}
                    onClick={() => setJoinRoomVisible(true)}
                  />
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sx={{
                    ...styles.menuButton,
                    // backgroundColor: "#e84057",
                    mb: 0,
                  }}
                >
                  <NeoButton
                    text="Deck Builder"
                    subText="Edit or create new battle decks."
                    width={100}
                    color="#e84057"
                    height={60}
                    onClick={() => navigate("/mycards")}
                  />
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sx={{
                    ...styles.menuButton,
                    // backgroundColor: "#00aaff",
                  }}
                >
                  <NeoButton
                    text="How To Play"
                    width={100}
                    color="#00aaff"
                    height={60}
                    onClick={() => setHowToPlayVisible(true)}
                  />
                </Grid> */}

                {/* ================= TOP LEFT COLUMN ================= */}
                <Box
                  style={{
                    position: "absolute",
                    left: "10px",
                    top: "20px",
                    paddingHorizontal: 6,
                    zIndex: 2,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    style={{
                      cursor: "pointer",
                      outline: "none",
                      marginBottom: "20px",
                    }}
                  >
                    <NeoMenuItem
                      icon={require("../@shared/assets/icons/market_icon.png")}
                      iconTop={true}
                      label={"SHOP"}
                      isRounded={false}
                      isLocked={userData.roles.includes("admin") ? false : true}
                      onClick={() => {
                        if (userData.roles.includes("admin")) {
                          setScreenLoading(true);
                          setTimeout(() => {
                            navigate("/store");
                          }, 500);
                        } else {
                          setMessage("Shop Coming Soon..");
                          setInfo(true);
                        }
                      }}
                    />
                  </motion.div>

                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    style={{
                      cursor: "pointer",
                      outline: "none",
                      margin: "10px 0px 20px",
                    }}
                  >
                    <NeoMenuItem
                      icon={require("../@shared/assets/icons/treasure_chest_icon.png")}
                      iconTop={true}
                      label={"BUYS"}
                      isRounded={false}
                      isLocked={userData.roles.includes("admin") ? false : true}
                      onClick={() => {
                        if (userData.roles.includes("admin")) {
                          setMyPurchasesVisible(true);
                        } else {
                          setMessage("Purchases Coming Soon..");
                          setInfo(true);
                        }
                      }}
                      redDot={
                        userData?.purchases?.filter((item) => !item.claimed)
                          .length > 0
                      }
                    />
                  </motion.div>

                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    style={{
                      cursor: "pointer",
                      outline: "none",
                      width: isMobile ? "45px" : "60px",
                      height: isMobile ? "45px" : "60px",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      position: "relative",
                      marginBottom: "20px",
                    }}
                    onClick={() => {
                      console.log("STORE");
                      setMessage("Coming Soon!");
                      setInfo(true);
                      //   handleNavigate("Test");
                      // setLeaderboardVisible(true);
                    }}
                  >
                    <img
                      src={require("../@shared/assets/icons/add_timed_quest_chest_icon.png")}
                      style={{
                        width: "100%",
                        height: "100%",
                        position: "absolute",
                        objectFit: "contain",
                        left: 0,
                        opacity: 0.8,
                      }}
                    />

                    <AddRounded
                      size={30}
                      color="white"
                      style={{
                        color: "#fff",
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: "translate(-50%, -50%)",
                      }}
                    />
                  </motion.div>

                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    style={{
                      cursor: "pointer",
                      outline: "none",
                      width: isMobile ? "45px" : "60px",
                      height: isMobile ? "45px" : "60px",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      position: "relative",
                      marginBottom: "20px",
                    }}
                    onClick={() => {
                      console.log("STORE");
                      setMessage("Coming Soon!");
                      setInfo(true);
                      //   handleNavigate("Test");
                      // setLeaderboardVisible(true);
                    }}
                  >
                    <img
                      src={require("../@shared/assets/icons/add_timed_quest_chest_icon.png")}
                      style={{
                        width: "100%",
                        height: "100%",
                        position: "absolute",
                        objectFit: "contain",
                        left: 0,
                        opacity: 0.8,
                      }}
                    />

                    <AddRounded
                      size={30}
                      color="white"
                      style={{
                        color: "#fff",
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: "translate(-50%, -50%)",
                      }}
                    />
                  </motion.div>

                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    style={{
                      cursor: "pointer",
                      outline: "none",
                      width: isMobile ? "45px" : "60px",
                      height: isMobile ? "45px" : "60px",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      position: "relative",
                      marginBottom: "20px",
                    }}
                    onClick={() => {
                      console.log("STORE");
                      setMessage("Coming Soon!");
                      setInfo(true);
                      //   handleNavigate("Test");
                      // setLeaderboardVisible(true);
                    }}
                  >
                    <img
                      src={require("../@shared/assets/icons/add_timed_quest_chest_icon.png")}
                      style={{
                        width: "100%",
                        height: "100%",
                        position: "absolute",
                        objectFit: "contain",
                        left: 0,
                        opacity: 0.8,
                      }}
                    />

                    <AddRounded
                      size={30}
                      color="white"
                      style={{
                        color: "#fff",
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: "translate(-50%, -50%)",
                      }}
                    />
                  </motion.div>
                </Box>

                {/* ================= BOTTOM LEFT COLUMN ================= */}

                {/* ================= TOP RIGHT COLUMN ================= */}
                <Box
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "20px",
                    width: "70px",
                    height: "100px",
                    zIndex: 1000,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    style={{
                      cursor: "pointer",
                      outline: "none",
                      //   marginBottom: "20px",
                    }}
                  >
                    <NeoMenuItem
                      icon={require("../@shared/assets/icons/clans_icon.png")}
                      iconTop={true}
                      label={"CLAN"}
                      isRounded={false}
                      isLocked={true}
                      onClick={() => {
                        setMessage("Clans Coming Soon..");
                        setInfo(true);
                      }}
                    />
                  </motion.div>
                </Box>

                {/* ================= BOTTOM RIGHT COLUMN ================= */}
                <Box
                  sx={{
                    position: "absolute",
                    right: "10px",
                    bottom: { xs: "25%", md: "16%" },
                    width: "70px",
                    height: "100px",
                    zIndex: 1000,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    style={{
                      cursor: "pointer",
                      outline: "none",
                      //   marginBottom: "20px",
                    }}
                  >
                    <NeoMenuItem
                      icon={require("../@shared/assets/icons/mail_icon.png")}
                      iconTop={true}
                      label={"MAIL"}
                      isRounded={false}
                      isLocked={true}
                      additionalStyle={{
                        marginBottom: "30px",
                      }}
                      onClick={() => {
                        setMessage("Mail Coming Soon..");
                        setInfo(true);
                      }}
                    />
                  </motion.div>

                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    style={{
                      cursor: "pointer",
                      outline: "none",
                      //   marginBottom: "20px",
                    }}
                  >
                    <NeoMenuItem
                      icon={require("../@shared/assets/icons/friends_icon.png")}
                      iconTop={true}
                      label={"FRIENDS"}
                      isRounded={false}
                      additionalStyle={{
                        marginBottom: "30px",
                      }}
                      isLocked={true}
                      onClick={() => {
                        setMessage("Friends Coming Soon..");
                        setInfo(true);
                      }}
                    />
                  </motion.div>

                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    style={{
                      cursor: "pointer",
                      outline: "none",
                      //   marginBottom: "20px",
                    }}
                  >
                    <NeoMenuItem
                      icon={getBadgeByLevel(userData.level).badge}
                      iconTop={true}
                      isLevelBadge={true}
                      label={"LEVEL"}
                      isRounded={false}
                      additionalStyle={{
                        marginBottom: "30px",
                      }}
                      onClick={() => {
                        setMessage("Level Info Coming Soon..");
                        setInfo(true);
                      }}
                    />
                  </motion.div>
                </Box>

                <Box
                  style={{
                    position: "absolute",
                    bottom: "10px",
                    right: "20px",
                    width: "180px",
                    zIndex: 20,
                  }}
                >
                  <NeoButton
                    text="PLAY"
                    width={100}
                    color="#e84057"
                    height={50}
                    onClick={() => {
                      if (
                        userData?.decks?.length === 0 &&
                        !userData?.completedTutorial
                      ) {
                        handleStartParty(true);
                        return;
                      }
                      setModalOpen(true);
                    }}
                  />
                </Box>

                <Box
                  style={{
                    position: "absolute",
                    bottom: "10px",
                    left: "10px",
                    width: "90px",
                    zIndex: 20,
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      position: "relative",
                    }}
                  >
                    <img
                      src={require("../@shared/assets/back-of-card.png")}
                      alt=""
                      style={{
                        width: "36%",
                        height: "auto",
                        position: "absolute",
                        top: "-70%",
                        left: "54%",
                        transform: "translate(-50%, 0%)",
                        zIndex: -1,
                      }}
                    />
                    <img
                      src={require("../@shared/assets/back-of-card.png")}
                      alt=""
                      style={{
                        width: "36%",
                        height: "auto",
                        position: "absolute",
                        top: "-60%",
                        left: "40%",
                        rotate: "-10deg",
                        transform: "translate(-50%, 0%)",
                        zIndex: -2,
                      }}
                    />
                    <img
                      src={require("../@shared/assets/back-of-card.png")}
                      alt=""
                      style={{
                        width: "36%",
                        height: "auto",
                        position: "absolute",
                        top: "-50%",
                        left: "70%",
                        rotate: "10deg",
                        transform: "translate(-50%, 0%)",
                        zIndex: -2,
                      }}
                    />
                    <NeoButton
                      text="CARDS"
                      width={100}
                      color={Theme.palette.primary.main}
                      height={50}
                      onClick={() => {
                        setScreenLoading(true);
                        setTimeout(() => {
                          navigate("/mycards");
                        }, 500);
                      }}
                    />
                  </div>
                </Box>

                {/* ================= AVATAR BOX ================= */}
                {userData?.decks?.length === 0 &&
                  !userData?.completedTutorial && (
                    <Typography
                      sx={{
                        position: "absolute",
                        bottom: { xs: "60%", md: "50%" },
                        left: "50%",
                        transform: "translate(-50%, 0%)",
                        width: "60%",
                        display: "flex",
                        justifyContent: "center",
                        padding: "10px",
                        zIndex: 1000,
                        background: "white",
                        borderRadius: "10px",
                      }}
                    >
                      Its time to make a Deck!
                      <br /> Press PLAY when you're ready to continue!
                    </Typography>
                  )}

                <Box
                  sx={{
                    position: "absolute",
                    bottom: { xs: "20%", md: "10%" },
                    left: "50%",
                    transform: "translate(-50%, 0%)",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <motion.div
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.25 }}
                    style={{
                      width: "100%",
                      height: "fit-content",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    <AvatarIdolAnimation
                      name={userData?.avatar?.name?.toLowerCase()}
                      style={{}}
                      onclick={() => setAvatarSelectorVisible(true)}
                    />
                  </motion.div>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Modal open={modalOpen}>
          <Grid
            item
            container
            xs={11}
            md={5}
            lg={3}
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              aspectRatio: "5/6",
            }}
          >
            <Grid
              item
              container
              xs={12}
              sx={{
                height: "100%",
                position: "relative",
                justifyContent: "center",
                py: 10,
              }}
            >
              <img
                src={require("../@shared/assets/game_menu.png")}
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  position: "absolute",
                  top: 0,
                  left: 0,
                }}
              />

              {!userData.test && (
                <Grid
                  item
                  container
                  xs={9}
                  sx={{
                    ...styles.menuButton,
                    // backgroundColor: "#00aaff",
                    mb: 0,
                  }}
                >
                  <NeoButton
                    text="Enter World"
                    // subText="Create a private or public battle."
                    width={100}
                    color="#00aaff"
                    height={60}
                    onClick={() => {
                      setModalOpen(false); // ✅ Close the modal here
                      handleStartParty(); // ✅ Then run transition logic
                    }}
                  />
                </Grid>
              )}

              <Grid
                item
                container
                xs={9}
                sx={{
                  ...styles.menuButton,
                  // backgroundColor: "#4b2cff",
                  mb: 0,
                }}
              >
                <NeoButton
                  text="Party Play"
                  subText="Enter a code or browse active rooms."
                  width={100}
                  color="#4b2cff"
                  height={60}
                  onClick={() => setJoinPartyVisible(true)}
                />
              </Grid>

              <Grid
                item
                container
                xs={9}
                sx={{
                  ...styles.menuButton,
                  // backgroundColor: "#4b2cff",
                  mb: 0,
                }}
              >
                <NeoButton
                  text="Quick Play"
                  subText="Enter a code or browse active rooms."
                  width={100}
                  color={Theme.palette.tirciary.main}
                  height={60}
                  onClick={() => setJoinRoomVisible(true)}
                />
              </Grid>

              <Grid
                item
                container
                xs={9}
                sx={{
                  ...styles.menuButton,
                  // backgroundColor: "#00aaff",
                }}
              >
                <NeoButton
                  text="How To Play"
                  width={100}
                  color="#00aaff"
                  height={60}
                  onClick={() => setHowToPlayVisible(true)}
                />
              </Grid>

              <Box
                sx={{
                  position: "absolute",
                  bottom: "-10px",
                  left: 0,
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <NeoButton
                  text="Cancel"
                  color={Theme.palette.secondary.main}
                  width={49}
                  onClick={() => setModalOpen(false)}
                />
              </Box>
            </Grid>
          </Grid>
        </Modal>

        <AvatarSelectorModal
          open={avatarSelectorVisible}
          onClose={() => setAvatarSelectorVisible(false)}
        />

        <JoinPartyModal
          visible={joinPartyVisible}
          onClose={() => setJoinPartyVisible(false)}
          userId={userData?.id}
        />
        <JoinRoomModal
          visible={joinRoomVisible}
          onClose={() => setJoinRoomVisible(false)}
          userId={userData?.id}
        />
        <StartRoomModal
          visible={startRoomVisible}
          onClose={() => setStartRoomVisible(false)}
          userId={userData?.id}
        />

        <HowToPlayModal
          visible={howToPlayVisible}
          onClose={() => setHowToPlayVisible(false)}
        />

        <QuestsAndRewardsModal
          visible={questsAndRewardsVisible}
          onClose={() => setQuestsAndRewardsVisible(false)}
        />

        <MyPurchasesModal
          visible={myPurchasesVisible}
          onClose={() => setMyPurchasesVisible(false)}
        />

        <MyQuestsModal
          visible={myQuestsVisible}
          onClose={() => setMyQuestsVisible(false)}
        />

        {/* <TownQuestsModal
					visible={townQuestsVisible}
					onClose={() => setTownQuestsVisible(false)}
					town={"Void City"}
					availableQuests={townQuests}
				  /> */}

        {packOpeningVisible && (
          <PackOpeningModal
            visible={packOpeningVisible}
            onClose={() => setPackOpeningVisible(false)}
          />
        )}

        <LeaderBoardModal
          visible={leaderboardVisible}
          onClose={() => setLeaderboardVisible(false)}
        />
      </Container>
    </Grid>
  );
};

const styles = {
  container: {
    display: "flex",
    flex: 1,
    position: "relative",
    overflow: { xs: "none", md: "hidden" },
  },
  text: { color: "#fff", fontWeight: "bold" },
  sectionBox: {
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    // backgroundColor: "#00000033",
  },
  sectionText: {
    color: "#fff",
    fontWeight: "bold",
    fontSize: 14,
  },
  userDataCotainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  menuButtonContainer: {
    width: "100%",
    mt: 2,
  },
  menuButton: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      opacity: 0.95,
    },
  },
  menuTitle: {
    color: "#fff",
    fontSize: "18px",
    fontWeight: "bold",
    textAlign: "center",
    textShadow: "1px 1px #000",
  },
  menuSubtitle: {
    color: "#fff",
    fontSize: "12px",
    fontWeight: 400,
    textAlign: "center",
    mt: "4px",
  },
};

export default Dashboard;
